import { HeaderService } from './../../../service/header.service';
import { Component, NgZone, OnInit } from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    copyright_year: any
    token: any
    header_islogin: boolean = false;

    email: any;
    username: any;

    constructor(private headerservice: HeaderService, private ngzone: NgZone) { }
    ngOnInit(): void {
        this.copyright_year = new Date().getFullYear()  // returns the current year
        this.headerservice.islogin.subscribe(res => {
            console.log('res', res);
            //  this.header_islogin = res;
            this.ngzone.run(() => {
                //   this.header_islogin = res;
                this.token = localStorage.getItem('core_spa_user_token');
                console.log('token', this.token);
                if (!this.token) {
                    console.log('not token', this.token);
                    this.header_islogin = false;


                } else {
                    this.header_islogin = true;
                    console.log('yes token', this.token);
                    this.email = localStorage.getItem('user_email');
                    this.username = localStorage.getItem('user_userName');
                    //   this.header_islogin = false;
                }

                console.log('login true>>>>>>>>>>>>>', this.header_islogin);
            });
        })

    }

}
